// ** React Imports
import * as Sentry from "@sentry/react"
import {useEffect} from "react"
import { Link } from 'react-router-dom'

// ** Custom Components
import Avatar from '@components/avatar'

// ** Utils

// ** Store & Actions
import { useDispatch, useSelector } from 'react-redux'
import { handleLogout } from '@store/authentication'

// ** Third Party Components
import {User, Power, ArrowLeft, Settings, DollarSign} from 'react-feather'
import useJwt from "../../../../auth/jwt/useJwt"

// ** Reactstrap Imports
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap'

import defaultAvatar from '@src/assets/images/portrait/small/avatar-s-11.jpg'
import { trans } from '../../../../configs/i18n'
import {handleChangeUserData} from "../../../../redux/authentication"
import {updateOddsType} from "../../../../redux/oddsType"
import {useSkin} from "../../../../utility/hooks/useSkin"
import { handleLogoutImpersonate } from '../../../../utility/impersonate/impersonateUtils'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)
const UserDropdown = () => {
  const dispatch = useDispatch()
  const userData = useSelector(state => state.auth?.user)
  const { skin } = useSkin()

  let userName = 'Użytkownik'
  if (userData?.user) {
    userName = userData.user.username

    Sentry.setUser({
      id: userData.user.id,
      email: userData.user.email,
      username: userName
    })
  }

  const admin = localStorage.getItem('admin_user')
  const userAvatar = (userData?.user && userData.user.avatar) || defaultAvatar
  const handleRestrictionAlert = (restriction) => {
    const restrictionFormatted = restriction.restrictionsFormatted

    return MySwal.fire({
      title: trans('user.alert.new_restrictions.title'),
      html: `${trans('user.alert.new_restrictions.text')} <br><br>
         <ul class="text-left">
           ${restrictionFormatted.map((item) => `<li style="text-align: left;"><small>${item}</small></li>`).join('')}
         </ul>
          <br>
          <span>${trans('user.alert.new_restrictions.endAt', {endAt: restriction.endAtFormatted})}</span>`,
      icon: 'error',
      background: skin === 'dark' ? '#283046' : '#fff',
      showCancelButton: false,
      confirmButtonText: trans("user.alert.new_restrictions.button.ok"),
      customClass: {
        confirmButton: 'btn btn-primary'
      },
      buttonsStyling: false
    })
  }
  useEffect(() => {
    useJwt.getMyUser().then(response => {
      const user = response.data.data
      dispatch(updateOddsType(user.oddType))
      const userLocalStorage = JSON.parse(localStorage.getItem('user'))
      userLocalStorage.user = user
      dispatch(handleChangeUserData(userLocalStorage))

      let hubUrl = response.headers.link.match(/<([^>]+)>;\s+rel=(?:mercure|"[^"]*mercure[^"]*")/)[1]
      const hub = new URL(hubUrl, window.origin)
      hub.searchParams.append('authorization', response.headers.mercureauthorization)
      hub.searchParams.append('topic', `/users/${userData.user.id}`)

      const eventSource = new EventSource(hub, {
        withCredentials: true,
        heartbeatTimeout: 180000
      })

      eventSource.onmessage = (event) => {
        const eventData = JSON.parse(event.data)
        if (eventData.type === 'update_user_new_restrictions') {
          const userLocalStorage = JSON.parse(localStorage.getItem('user'))
          userLocalStorage.user = eventData.user
          dispatch(handleChangeUserData(userLocalStorage))
          handleRestrictionAlert(eventData.data)
        }
      }

      eventSource.onerror = (event) => {
        // eslint-disable-next-line no-console
        console.log(event)
      }
      eventSource.onopen = () => {
      }
    })
  }, [])

  return (<>
    <UncontrolledDropdown tag='li' className='dropdown-user nav-item'>
      <DropdownToggle href='/' tag='a' className='nav-link dropdown-user-link' onClick={e => e.preventDefault()}>
        <div className='user-nav d-sm-flex d-none'>
          <span className='user-name fw-bold'>{userName}</span>
        </div>
        <Avatar img={userAvatar} imgHeight='40' imgWidth='40' status='online' />
      </DropdownToggle>
      <DropdownMenu end>
        <DropdownItem tag={Link} to={`/user/${userData?.user?.username}`}>
          <User size={14} className='me-75' />
          <span className='align-middle'>{trans("menu.profil")}</span>
        </DropdownItem>
        <DropdownItem tag={Link} to={`/user/settings`}>
          <Settings size={14} className='me-75' />
          <span className='align-middle'>{trans("menu.top.settings")}</span>
        </DropdownItem>
        <DropdownItem tag={Link} to={`/user/tipster-settings`}>
          <DollarSign size={14} className='me-75' />
          <span className='align-middle'>{trans("menu.top.settings_tipster")}</span>
        </DropdownItem>
        <DropdownItem divider />
        {admin && <DropdownItem tag={Link} to={`/`} onClick={() => handleLogoutImpersonate(dispatch)}>
          <ArrowLeft size={14} className='me-75' />
          <span className='align-middle'>{trans("menu.admin")}</span>
        </DropdownItem>}
        <DropdownItem tag='a' href='#' onClick={() => dispatch(handleLogout())}>
          <Power size={14} className='me-75' />
          <span className='align-middle'>{trans("menu.logout")}</span>
        </DropdownItem>

      </DropdownMenu>
    </UncontrolledDropdown>
    </>
  )
}

export default UserDropdown
